export default {
   email: "info@kjrwug.de"
};